export function isLocalDev() {
  return import.meta.env.DEV;
}
